import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.AGGREGATE_DATASET, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) =>
  Helpers.coalesceMessages(
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.groupColumns,
      'Cannot group by the same column more than once.'
    ),
    // Get column names that are both being aggregated and grouped
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      [
        ...new Set(config.groupColumns),
        ...new Set(
          config.aggregations
            .filter(
              (agg): agg is Exclude<typeof agg, {aggregationFunction: 'COUNT'}> =>
                agg.aggregationFunction !== 'COUNT'
            )
            .map((agg) => agg.column)
        ),
      ],
      'Cannot group by a column and aggregate it.',
      'Columns being aggregated and grouped: '
    ),
    config.aggregations
      .filter(
        (agg): agg is Extract<typeof agg, {aggregationFunction: 'STRING_AGG'}> =>
          agg.aggregationFunction === 'STRING_AGG' && agg.orderByColumns != null
      )
      .map((agg) =>
        Helpers.getDuplicateColumnsMessage(
          dataFrameSpec,
          agg.orderByColumns.map((orderByColumn) => orderByColumn.column),
          'Cannot order by the same column more than once.'
        )
      )
  );

export default {
  stepType: PipelineStepType.AGGREGATE_DATASET,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.AGGREGATE_DATASET, 0>;
